export default __webpack_public_path__ + "static/banner-bg-28e7b1602eb1993680ff7e8c3d45c664.jpg";